import { DynamicStandaloneJwVideoShoppable } from '@/components/JwVideo/Shoppable';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorShoppableVideo: LabradorComponent = ({ type, meta, data }) => {
  const { videoData } = data;

  return <DynamicStandaloneJwVideoShoppable mediaId={videoData.videoID} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorShoppableVideo;
